<div class="modal-header d-flex justify-content-between">
  <h6 class="modal-title" style="color: grey;">
    {{ curentLang === 'en' ? 'Add Category' : (curentLang === 'ar' ? 'إضافة تصنيف' : 'הוספת קטגוריה') }}
  </h6>
  <button type="button" class="btn-close" aria-label="Close" (click)="cancel()"></button>
</div>

<div class="modal-body">
  <form [formGroup]="form" novalidate [ngClass]="{ 'was-validated': validate }">
    <div class="row">
      <div class="mb-3 col-md-12">
        <label class="form-label" style="color: grey;">
          {{ curentLang === 'en' ? 'Name' : (curentLang === 'ar' ? 'الاسم' : 'שם') }}
          <span class="text-danger">*</span>
        </label>
        <input class="form-control" formControlName="name" maxlength="80"
          [placeholder]="curentLang === 'en' ? 'Category name' : (curentLang === 'ar' ? 'اسم التصنيف' : 'שם קטגוריה')" />
      </div>
      <div class="mb-3 col-md-6">
        <label class="form-label" style="color: grey;">
          {{ curentLang === 'en' ? 'Code' : (curentLang === 'ar' ? 'الكود' : 'קוד') }}
        </label>
        <input class="form-control" formControlName="code" maxlength="40" />
      </div>
      <div class="mb-3 col-md-6">
        <label class="form-label" style="color: grey;">
          {{ curentLang === 'en' ? 'Sort Order' : (curentLang === 'ar' ? 'الترتيب' : 'סדר') }}
        </label>
        <input class="form-control" type="number" formControlName="sort_order" />
      </div>
      <div class="mb-3 col-md-12">
        <label class="form-label" style="color: grey;">
          {{ curentLang === 'en' ? 'Category Image (AI)' : (curentLang === 'ar' ? 'صورة التصنيف (AI)' : 'תמונת קטגוריה (AI)') }}
        </label>
        <div class="d-flex flex-wrap align-items-center gap-3">
          <img *ngIf="currentImageUrl" [src]="currentImageUrl" alt="" class="category-image-preview category-thumb-clickable"
            (click)="openImagePreview(currentImageUrl)" />
          <div class="form-check">
            <input class="form-check-input" type="checkbox" id="shared_add_cat_ai" formControlName="generate_ai_image" />
            <label class="form-check-label" for="shared_add_cat_ai" style="color: grey;">
              {{ curentLang === 'en' ? 'Generate AI image on save (from name)' : (curentLang === 'ar' ? 'توليد صورة AI عند الحفظ (من الاسم)' : 'צור תמונת AI בשמירה (מהשם)') }}
            </label>
          </div>
          <input class="form-control form-control-sm" style="max-width:280px;" type="text"
            formControlName="ai_image_prompt"
            [placeholder]="curentLang === 'en' ? 'Custom AI prompt (optional)' : (curentLang === 'ar' ? 'برومبت يدوي (اختياري)' : 'פרומפט ידני (אופציונלי)')" />
          <button type="button" class="btn btn-sm btn-outline-secondary" (click)="generateAiImage()">
            <i class="fa fa-magic mx-1"></i>
            {{ curentLang === 'en' ? 'Preview AI' : (curentLang === 'ar' ? 'معاينة AI' : 'תצוגת AI') }}
          </button>
          <small *ngIf="pendingPreviewKey" class="text-success">
            {{ curentLang === 'en' ? 'Preview ready — will apply on save' : (curentLang === 'ar' ? 'المعاينة جاهزة — تُعتمد عند الحفظ' : 'התצוגה מוכנה — תוחל בשמירה') }}
          </small>
        </div>
      </div>
    </div>
  </form>
</div>

<div class="modal-footer">
  <button type="button" class="btn btn-sm" style="background:#141414;color:#fff;" (click)="save()">
    {{ curentLang === 'en' ? 'Confirm' : (curentLang === 'ar' ? 'تأكيد' : 'אישור') }}
  </button>
  <button type="button" class="btn btn-sm btn-danger" (click)="cancel()">
    {{ curentLang === 'en' ? 'Back' : (curentLang === 'ar' ? 'رجوع' : 'חזרה') }}
  </button>
</div>

<ng-template #aiPreviewModal let-modal>
  <div class="modal-header d-flex justify-content-between">
    <h6 class="modal-title" style="color: grey;">
      {{ curentLang === 'en' ? 'AI Image Preview' : (curentLang === 'ar' ? 'معاينة صورة AI' : 'תצוגה מקדימה של תמונת AI') }}
    </h6>
    <button type="button" class="btn-close" (click)="modal.dismiss()"></button>
  </div>
  <div class="modal-body text-center">
    <img *ngIf="aiPreviewUrl" [src]="aiPreviewUrl" alt="AI preview" class="category-ai-preview" />
    <p class="text-muted mt-2 mb-0">
      {{ curentLang === 'en' ? 'Approve to use this image on the category.' : (curentLang === 'ar' ? 'اعتمد لاستخدام هذه الصورة على التصنيف.' : 'אשר כדי להשתמש בתמונה בקטגוריה.') }}
    </p>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-sm" style="background:#141414;color:#fff;" (click)="approveAiImage(modal)">
      {{ curentLang === 'en' ? 'Approve' : (curentLang === 'ar' ? 'اعتماد' : 'אישור') }}
      <i class="fa fa-check-circle mx-1"></i>
    </button>
    <button type="button" class="btn btn-sm btn-danger" (click)="modal.close()">
      {{ curentLang === 'en' ? 'Cancel' : (curentLang === 'ar' ? 'إلغاء' : 'ביטול') }}
    </button>
  </div>
</ng-template>

<ng-template #imageViewModal let-modal>
  <div class="modal-header d-flex justify-content-between">
    <h6 class="modal-title" style="color: grey;">
      {{ curentLang === 'en' ? 'Category Image' : (curentLang === 'ar' ? 'صورة التصنيف' : 'תמונת קטגוריה') }}
    </h6>
    <button type="button" class="btn-close" (click)="modal.dismiss()"></button>
  </div>
  <div class="modal-body text-center">
    <img *ngIf="imageViewUrl" [src]="imageViewUrl" alt="" class="category-image-full" />
  </div>
</ng-template>
